import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_TABLE_SETTING = NS + 'CHANGE_TABLE_SETTING'

export const FIND_FOIL_LIST_REQUEST = NS + 'FIND_FOIL_LIST_REQUEST'
export const FIND_FOIL_LIST_SUCCESS = NS + 'FIND_FOIL_LIST_SUCCESS'
export const FIND_FOIL_LIST_ERROR = NS + 'FIND_FOIL_LIST_ERROR'



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/info-table/type.js